import * as React from 'react';
import SoundOffOutlined from './sound-off-outlined';
import SoundOffFilled from './sound-off-filled';
import type { IconCombinedProps } from './types';
const SoundOffCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <SoundOffFilled ref={ref} {...rest} />;
  }
  return <SoundOffOutlined ref={ref} {...rest} />;
});
export default SoundOffCombined;